export default __webpack_public_path__ + "static/poster-0f501f8743a6088781ab162916997903.png";